import { render, staticRenderFns } from "./PigTailLabel.vue?vue&type=template&id=303ac9a8&scoped=true&"
import script from "./PigTailLabel.vue?vue&type=script&lang=js&"
export * from "./PigTailLabel.vue?vue&type=script&lang=js&"
import style0 from "./PigTailLabel.vue?vue&type=style&index=0&id=303ac9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ac9a8",
  null
  
)

export default component.exports